<template>
  <div :class="[{purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <CustomDate
          placeholder="Дата начала"
          @change_date="(value) => onChange('date_begin', value)"
          :value="this.formData.date_begin"
          :fullWidth="true"
        />
      </div>
      <div class="form__item">
        <CustomDate
          placeholder="Дата окончания"
          @change_date="(value) => onChange('date_end', value)"
          :value="this.formData.date_end"
          :fullWidth="true"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import CustomDate from "@/components/form/CustomDate";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import { useAppStore } from "@/services/store/app";
import { changeDateEntranceDocument } from "@/views/ResidentialSettings/services";

export default {
  name: "change-entrance-document",
  components: {CustomDate, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      materials: [],
      loading: false,
      formData: {
        date_begin: this.data?.body?.date_begin || '',
        date_end: this.data?.body?.date_end || '',
        floor_map_document_id: this.data?.data?.floor_map_document_id || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      const res = await changeDateEntranceDocument(this.formData, this.data?.params)
      this.loading = false
      if (!res) return
      if(this.data?.onSubmit)
        await this.data?.onSubmit(res)
      this.showSucceedSnackbar()
      this.closeModal()
    },
  },
  setup() {
    const {closeModal} = useAppStore()
    const {showSucceedSnackbar} = useCustomSnackbar()
    return {showSucceedSnackbar, closeModal}
  },
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  min-width: 350px;
  gap: 15px;
  margin-top: 10px;

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>
